<template>
  <div class="page-container">
    <!-- Bütün sayfayı kaplayan loading ekranı -->
    <div v-if="loading" class="loading-overlay">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
      <p>Yükleniyor...</p>
    </div>

    <div class="row" v-show="!loading">
      <div class="container">
        <vue-good-table
            mode="remote"
            :rows="rows"
            :columns="columns"
            :line-numbers="true"
        >
          <div slot="table-actions">
            <b-button block class="mt-2" variant="success" @click="showAddModal = true">Ürün Tipi Ekle</b-button>
          </div>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'actions'">
              <div class="d-flex justify-content-center gap-2 px-2">
                <b-button size="sm" variant="outline-primary" @click.stop="showEdit(props.row)">
                  <b-icon icon="pencil" class="mr-1" />
                  Güncelle
                </b-button>

                <b-button size="sm" variant="outline-danger" @click.stop="showDelete(props.row.id)">
                  <b-icon icon="trash" class="mr-1" />
                  Sil
                </b-button>
              </div>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>

    <b-modal v-model="showAddModal" title="Yeni Ürün Tipi Ekle" @ok="createProductType">
      <b-form-group label="Ürün Tipi Adı">
        <b-form-input v-model="newProductTypeName" required />
      </b-form-group>
    </b-modal>

    <b-modal v-model="showEditModal" title="Ürün Tipi Güncelle" @ok="editProductType">
      <b-form-group label="Ürün Tipi Adı">
        <b-form-input v-model="editedProductTypeName" required />
      </b-form-group>
    </b-modal>

    <b-modal v-model="showDeleteModal" title="Ürün Tipi Sil"
             ok-title="Evet, Sil"
             cancel-title="Vazgeç"
             ok-variant="danger"
             @ok="deleteProductType">
      <p class="my-2">Bu ürün tipini silmek istediğinizden emin misiniz?</p>
    </b-modal>
  </div>
</template>

<script>
import ProductTypeDefinitionService from '../../service/ProductTypeDefinitionService';

export default {
  name: 'AdminProductTypeList',
  data() {
    return {
      loading: false,  // ✅ Sayfa yükleniyor mu?
      columns: [
        {
          field: 'id',
          hidden: true
        },
        {
          label: 'Ürün Tipi',
          field: 'name',
          sortable: false,
        },
        {
          field: 'actions',
          sortable: false,
        }
      ],
      rows: [],
      showAddModal: false,
      showEditModal: false,
      showDeleteModal: false,
      newProductTypeName: '',
      editedProductTypeName: '',
      editProductTypeRecord: undefined,
      deleteId: undefined,
    };
  },
  methods: {
    async loadItems() {
      this.loading = true;
      try {
        this.rows = await ProductTypeDefinitionService.list();
      } finally {
        this.loading = false;
      }
    },

    async createProductType() {
      if (!this.newProductTypeName) return;
      this.loading = true;
      try {
        await ProductTypeDefinitionService.create({ name: this.newProductTypeName });
      } catch (error) {
        this.$alert(this, error.message);
      } finally {
        this.loading = false;
      }
      this.newProductTypeName = '';
      this.showAddModal = false;
      await this.loadItems();
    },

    async showEdit(productType) {
      this.editProductTypeRecord = productType;
      this.editedProductTypeName = productType.name;
      this.showEditModal = true;
    },

    async editProductType() {
      if (!this.editedProductTypeName) return;
      this.loading = true;
      try {
        await ProductTypeDefinitionService.update({ id: this.editProductTypeRecord.id, name: this.editedProductTypeName });
      } catch (error) {
        this.$alert(this, error.message);
      } finally {
        this.loading = false;
      }
      this.editedProductTypeName = '';
      this.showEditModal = false;
      await this.loadItems();
    },

    async showDelete(productTypeId) {
      this.deleteId = productTypeId;
      this.showDeleteModal = true;
    },
    async deleteProductType() {
      this.loading = true;
      try {
        await ProductTypeDefinitionService.delete(this.deleteId);
      } catch (error) {
        this.$alert(this, error.message);
      } finally {
        this.loading = false;
      }
      this.deleteId = undefined;
      if (this.selectedProductType && this.selectedProductType.id === this.deleteId) {
        this.selectedProductType = null;
      }
      await this.loadItems();
    },
  },
  async mounted() {
    await this.loadItems();
  }
};
</script>

<style>
/* Sayfanın üstüne loading efekti ekleyen CSS */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Yarı saydam beyaz */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 1000;
  font-size: 20px;
}
</style>
